module.exports = __webpack_public_path__ + "img/w8.eafe4ef1.png";